// extracted by mini-css-extract-plugin
export var faqSection = "index-module--faqSection--Nnh0U";
export var faqSectionContainer = "index-module--faqSectionContainer--DE9T+";
export var faqSectionTitle = "index-module--faqSectionTitle--d0YL+";
export var faqSectionQuestions = "index-module--faqSectionQuestions--rYonW";
export var accordionSection = "index-module--accordionSection--6iSfV";
export var angle = "index-module--angle--aSmiY";
export var button = "index-module--button--JYVkR";